import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";
import AvatarIcon from "@/assets/images/icons/chat_avatar.svg?inline";

import { mapState } from "vuex";

export default {
  name: "channel",

  data() {
    return {
      cacheCurrentChannel: {},
      lastUpdated: "",
      unconsumedMessagesCount: 0,
      lastConsumedMessagesIndex: 0,

      channelOpponentUser: {},
      channelCurrentUser: {},

      twilioOpponentUser: {},
      twilioCurrentUser: {}
    };
  },

  props: {
    channelData: {
      type: Object,
      default: {
        sid: null
      }
    },
    userData: Object
  },

  mounted: function() {
    this.setChanelInfo();
  },

  computed: {
    ...mapState(["twilioMessagesCounter"]),

    channelTitle() {
      if (
        this.twilioOpponentUser.attributes &&
        this.twilioOpponentUser.attributes.full_name
      ) {
        return this.twilioOpponentUser.attributes.full_name;
      }
    },

    channelAvatar() {
      if (
        this.twilioOpponentUser.attributes &&
        this.twilioOpponentUser.attributes.avatar
      ) {
        return this.twilioOpponentUser.attributes.avatar;
      }
    }
  },

  methods: {
    setChanelInfo() {
      this.channelData.getChannel().then(currentChannel => {
        // listener UPDATE channel
        currentChannel.on("messageAdded", this.updateMemberMessageReadStatus);

        this.cacheCurrentChannel = currentChannel;

        this.lastUpdated = currentChannel.lastMessage
          ? currentChannel.lastMessage.timestamp
          : "";

        this.lastConsumedMessagesIndex = currentChannel.lastMessage
          ? currentChannel.lastMessage.index
          : null;

        currentChannel.getMembers().then(currentMembers => {
          currentMembers.forEach(channelMember => {
            channelMember.getUser().then(twilioUser => {
              if (twilioUser.attributes.id != this.userData.id) {
                // OPPONENT USER
                this.channelOpponentUser = channelMember;
                this.twilioOpponentUser = twilioUser;
              } else {
                // CURRENT USER
                this.channelCurrentUser = channelMember;
                this.twilioCurrentUser = twilioUser;

                this.unconsumedMessagesCount =
                  this.lastConsumedMessagesIndex -
                  this.channelCurrentUser.attributes.lastMsgIndex;
              }
            });
          });
        });
      });
    },

    updateMemberMessageReadStatus(newMessage) {
      this.lastUpdated = new Date(newMessage.timestamp);

      if (this.channelCurrentUser.identity == newMessage.author) {
        let attributes = {
          lastMsgIndex: newMessage.index,
          lastMsgDate: newMessage.timestamp
        };

        this.channelCurrentUser
          .updateAttributes(attributes)
          .then(updatedCurrentUser => {
            this.updateGlobalCounter(this.unconsumedMessagesCount, "decrease");

            this.unconsumedMessagesCount = 0;
          });
      } else {
        // this.updateGlobalCounter(this.unconsumedMessagesCount, "increase");
        this.unconsumedMessagesCount += 1;
      }
    },

    updateGlobalCounter(oldCounter, type = "decrease") {
      let counter;

      switch (type) {
        case "decrease":
          counter = this.twilioMessagesCounter - oldCounter;
          this.$store.commit("setTwilioMessagesCounter", counter);

          break;

        case "increase":
          // counter = oldCounter + 1;

          // this.$store.commit("setTwilioMessagesCounter", counter);

          break;
      }
    },

    isSelectedChannel() {
      this.channelData.getChannel().then(currentChannel => {

        let attributes = {
          lastMsgIndex: currentChannel.lastMessage
            ? currentChannel.lastMessage.index
            : "",
          lastMsgDate: currentChannel.lastMessage
            ? currentChannel.lastMessage.timestamp
            : ""
        };

        this.channelCurrentUser
          .updateAttributes(attributes)
          .then(updatedChannelUser => {
            this.updateGlobalCounter(this.unconsumedMessagesCount, "decrease");

            this.unconsumedMessagesCount = 0;
          });
      });
    }
  },

  beforeDestroy() {
    this.cacheCurrentChannel.removeListener(
      "messageAdded",
      this.updateMemberMessageReadStatus
    );
  },

  components: {
    LoadingIcon,
    AvatarIcon
  }
};
